<!--C9产品-->
<template>
	<div class="home-main C9_products clearfix" > 
		<div class="main" v-loading="loading">
			<div class="main_title">
				<span class="title-cn">C9产品</span>
				<span class="title-en">/C9 Products</span>
				 <div class="main-title-right" v-loading="loading">
					<el-button size="medium" class="danger" @click="triallDialogOpen">产品试用</el-button>
					<el-button size="medium" class="primary" @click="buyFirstDialogOpen">申请购买</el-button>
				</div> 
			</div>
			<!--筛选部分start-->
			<div class="product-selector">
				<div class="selector-left">
					<div class="block">
						<span class="demonstration">开通时间</span>
						<el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.openingDateStart" type="date" align="right" :picker-options="pickerOptions1" size="small">
						</el-date-picker>
					</div>
					<div class="block">
						<span class="demonstration">到</span>
						<el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.openingDateEnd" type="date" align="right" :picker-options="pickerOptions2" size="small">
						</el-date-picker>
					</div>
					<div class="block">
						<span class="demonstration">过期时间</span>
						<el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.expirationDateStart" type="date" align="right" :picker-options="pickerOptions3" size="small">
						</el-date-picker>
					</div>
					<div class="block">
						<span class="demonstration">到</span>
						<el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.expirationDateEnd" type="date" align="right" :picker-options="pickerOptions4" size="small">
						</el-date-picker>
					</div>
				</div>
				<div class="selector-center">
					<div class="demo-input-suffix">
						<p>授权客户名称</p>
						<el-input v-model="searchOption.customerName" size="small" clearable></el-input>
					</div>
					<div class="demo-input-suffix">
						<p>授权码</p>
						<el-input v-model="searchOption.code" size="small" clearable></el-input>
					</div>
				</div>
				<div class="selector-right">
					<el-button size="small" class="warning" @click="search">搜索</el-button>
					<el-button size="small" @click="restSearch">重置</el-button>
				</div>
			</div>
			<!--筛选部分end-->

			<div class="product-main-line"></div>

			<!--产品列表start-->
			<div class="product-main-list">
				<el-table :data="tableData" height="100%" style="width:100%" stripe>
					<el-table-column width="20">
					</el-table-column>
					<el-table-column label="版本">
						<template slot-scope="scope">
							<span>{{ scope.row.edition }}</span>
						</template>
					</el-table-column>
					<el-table-column label="授权码">
						<template slot-scope="scope">
							<span>{{ scope.row.code }}</span>
						</template>
					</el-table-column>
					<el-table-column label="授权客户名称">
						<template slot-scope="scope">
							<span>{{ scope.row.name }}</span>
						</template>
					</el-table-column>
					<!-- <el-table-column label="授权用户数">
						<template slot-scope="scope">
							<span>{{ scope.row.user_count }}</span>
						</template>
					</el-table-column> -->
          <el-table-column>
						<template slot-scope="scope">
							<span>{{ scope.row.create_time }}</span>
						</template>
					</el-table-column>
					<el-table-column label="过期时间">
						<template slot-scope="scope">
							<span>{{ scope.row.expire_time }}</span>
						</template>
					</el-table-column>
					<el-table-column label="状态">
						<template slot-scope="scope">
							<span>{{ getAuthStatus(scope.row.status) }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="400" class="table-status">
						<template slot-scope="scope">
							<!-- <span v-if="scope.row.status != 3">
								<el-button size="mini" type="success"  @click="addPointOpen(scope.$index, scope.row)">加点</el-button>
								<el-button v-if="scope.row.expire_time !='买断'" size="mini" type="primary"  @click="renewOpen(scope.$index, scope.row)">续费</el-button>
							</span>
							<el-button v-else size="mini" type="primary" @click="renewOpen(scope.$index, scope.row)">购买</el-button>
							<el-button size="mini" type="danger"  @click="changeKeyOpen(scope.$index, scope.row)">修改密码</el-button>
							<el-button size="mini" type="success"  @click="editCustomerOpen(scope.$index, scope.row)">编辑信息</el-button> -->
							<el-button size="mini" type="primary" @click="certificateOpen(scope.$index, scope.row)">授权证书</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagination">
				<el-pagination
					:disabled="!pagination.use"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pagination.currentPage"
					:page-sizes="[ 20, 30, 50, 100]"
					:page-size="pagination.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total">
				</el-pagination>
			</div>
			<!--产品列表end-->

			<!--产品试用弹窗start-->
			<el-dialog :before-close="restTriallForm"  title="申请试用C9产品" :visible.sync="triallDialog" width="506px" class="triallDialog">
				<el-form :model="triallForm" ref="triallForm" :rules="triallFormRules">
					<el-form-item  label="授权码" prop="code" :label-width="formLabelWidth">
						<el-input 
						@change="verifyCodeOnInput"
						:disabled="verifyCodeResult.loading"
						:suffix-icon="verifyCodeResult.icon"
						 v-model="triallForm.code" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="授权码密码" prop="key" :label-width="formLabelWidth">
						<el-input v-model="triallForm.key" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="公司名称" prop="name" :label-width="formLabelWidth">
						<el-input v-model="triallForm.name" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="联系人" prop="contact_name" :label-width="formLabelWidth">
						<el-input v-model="triallForm.contact_name" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="联系人电话" prop="phone" :label-width="formLabelWidth">
						<el-input v-model="triallForm.phone" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="联系人邮箱" prop="email" :label-width="formLabelWidth">
						<el-input v-model="triallForm.email" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="选择版本" :label-width="formLabelWidth">
						<el-select v-model="triallForm.edition" placeholder="请选择">
							<el-option v-for="(item, key) in meEdition" :key="key" :label="item" :value="key">
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="用户数" prop="user_count" :label-width="formLabelWidth">
						<el-input v-model.number="triallForm.user_count" autocomplete="off"></el-input>
					</el-form-item> -->
					<el-form-item label="试用期限" :label-width="formLabelWidth">
						<el-select v-model="triallForm.trail_days" placeholder="请选择">
							<el-option v-for="item in triallDate" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="cancel('triallForm', triallDialog = false)">取 消</el-button>
					<el-button class="primary" @click="triallFormSubmit">提 交</el-button>
				</div>
			</el-dialog>
			<!--产品试用弹窗end-->
			
			<!--申请购买弹窗start-->
			<el-dialog :before-close="restbuyFirstForm" title="购买C9产品" :visible.sync="buyFirstDialog" width="506px" class="buyFirstDialog">
				<el-form v-if="!payTableShow" :model="buyFirstForm" ref="buyFirstForm" :rules="buyFirstFormRules">
					<el-form-item label="授权码" prop="code" :label-width="formLabelWidth">
						<el-input v-model="buyFirstForm.code"
							@change="verifyCodeOnInput"
							:disabled="verifyCodeResult.loading"
							:suffix-icon="verifyCodeResult.icon"
						 	autocomplete="off">
						</el-input>
					</el-form-item>
					<el-form-item label="授权码密码" prop="key" :label-width="formLabelWidth">
						<el-input v-model="buyFirstForm.key" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="授权客户名称" prop="name" :label-width="formLabelWidth">
						<el-input v-model="buyFirstForm.name" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="客户联系人" prop="contact_name"  :label-width="formLabelWidth">
						<el-input v-model="buyFirstForm.contact_name" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="联系人电话" prop="phone" :label-width="formLabelWidth">
						<el-input v-model="buyFirstForm.phone" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="联系人邮箱" prop="email" :label-width="formLabelWidth">
						<el-input v-model="buyFirstForm.email" autocomplete="off"></el-input>
					</el-form-item>
					<!-- <el-form-item label="购买用户数" prop="user_count" :label-width="formLabelWidth">
						<el-input v-model.number="buyFirstForm.user_count" autocomplete="off"></el-input>
					</el-form-item> -->
					<el-form-item label="选择版本" :label-width="formLabelWidth">
						<el-select v-model="buyFirstForm.edition" placeholder="请选择">
							<el-option v-for="(item, key) in meEdition" :key="key" :label="item" :value="key">
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="购买期限" :label-width="formLabelWidth">
						<el-select v-model="buyFirstForm.months" placeholder="请选择">
							<el-option v-for="item in buyDate" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="支付方式" :label-width="formLabelWidth">
						<el-radio-group v-model="buyFirstForm.pay_type">
							<el-radio :label="0">专用币</el-radio>
							<el-radio :label="1">专用币优先</el-radio>
							<el-radio :label="2">通用币</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<div v-if="payTableShow" class="clearfix">
					<el-table 
					:data="payTableData"
					border
					style="width: 100%">
					<el-table-column
					prop="code"
					label="授权码"
					width="180">
					</el-table-column>
					<!-- <el-table-column
					prop="user_count"
					label="用户数"
					width="80">
					</el-table-column> -->
					<!-- <el-table-column
					prop="months"
					label="购买时长">
					 <template slot-scope="scope">
						<span>{{ scope.row.months }}个月</span>
					</template>
					</el-table-column> -->
					<el-table-column
					prop="price"
					label="价格">
					</el-table-column>
				</el-table>
					<el-alert class="alert"
						title="支付描述"
						:type="alertType"
						:closable="false"
						:description="payDescription">
					</el-alert>
					<el-button v-if="payBtnShow" class="primary pay_btn" @click="firstBuySure">确认支付</el-button>
				</div>
				<div v-if="!payTableShow" slot="footer" class="dialog-footer">
					<el-button @click="cancel('buyFirstForm', buyFirstDialog = false)">取消购买</el-button>
					<el-button class="primary" @click="buyFirstSubmit">提交</el-button>
				</div>
			</el-dialog>
			<!--申请购买弹窗end-->
			
			<!--产品加点弹窗start-->
			<el-dialog :before-close="restAddPointForm" title="C9产品加点" :visible.sync="addPointDialog" width="600px" class="addPointDialog">
				<el-form v-if="!payTableShow" ref="addPointForm" :model="addPointForm" :rules="addPointFormRules">
					<el-form-item label="授权码" :label-width="formLabelWidth">
						<el-input v-model="addPointForm.code" autocomplete="off" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="授权客户名称" :label-width="formLabelWidth">
						<el-input v-model="addPointForm.name" autocomplete="off" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="已购买用户数" :label-width="formLabelWidth">
						<el-input v-model="addPointForm.old_user_count" autocomplete="off" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="新增用户数" prop="user_count" :label-width="formLabelWidth">
						<el-input v-model.number="addPointForm.user_count" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="支付方式" :label-width="formLabelWidth">
						<el-radio-group v-model="addPointForm.pay_type">
							<el-radio :label="0">专用币</el-radio>
							<el-radio :label="1">专用币优先</el-radio>
							<el-radio :label="2">通用币</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<div v-if="payTableShow" class="clearfix">
					<el-table 
					:data="payTableData"
					border
					style="width: 100%">
					<el-table-column
					prop="code"
					label="授权码"
					width="180">
					</el-table-column>
					<el-table-column
					prop="user_count"
					label="用户数"
					width="80">
					</el-table-column>
					<el-table-column
					prop="months"
					label="购买时长">
					 <template slot-scope="scope">
						<span>{{ scope.row.months }}个月</span>
					</template>
					</el-table-column>
					<el-table-column
					prop="price"
					label="价格">
					</el-table-column>
				</el-table>
					<el-alert class="alert"
						title="支付描述"
						:type="alertType"
						:closable="false"
						:description="payDescription">
					</el-alert>
					<el-button v-if="payBtnShow" class="primary pay_btn" @click="addPointPay">确认支付</el-button>
				</div>
				<div slot="footer" class="dialog-footer" v-if="!payTableShow">
					<el-button @click="cancel('addPointForm', addPointDialog = false)">取 消</el-button>
					<el-button class="primary" @click="addPointSubmit">提 交</el-button>
				</div>
			</el-dialog>
			<!--产品加点弹窗end-->
			
			<!--产品续费弹窗start-->
			<el-dialog :before-close="restRenewForm"  title="C9产品续费" :visible.sync="renewDialog" width="506px" class="renewDialog">
				<el-form v-if="!payTableShow" ref="renewForm" :rules="renewFormRules" :model="renewForm">
					<el-form-item label="授权码" :label-width="formLabelWidth">
						<el-input v-model="renewForm.code" autocomplete="off" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="授权客户名称" :label-width="formLabelWidth">
						<el-input v-model="renewForm.name" autocomplete="off" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="已购买用户数" :label-width="formLabelWidth">
						<el-input v-model="renewForm.old_user_count" autocomplete="off" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="购买期限" :label-width="formLabelWidth">
						<el-select v-model="renewForm.months" placeholder="请选择">
							<el-option v-for="item in buyDate" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="支付方式" :label-width="formLabelWidth">
						<el-radio-group v-model="renewForm.pay_type">
							<el-radio :label="0">专用币</el-radio>
							<el-radio :label="1">专用币优先</el-radio>
							<el-radio :label="2">通用币</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<div v-if="payTableShow" class="clearfix">
					<el-table 
					:data="payTableData"
					border
					style="width: 100%">
					<el-table-column
					prop="code"
					label="授权码"
					width="180">
					</el-table-column>
					<el-table-column
					prop="user_count"
					label="用户数"
					width="80">
					</el-table-column>
					<el-table-column
					prop="months"
					label="购买时长">
					 <template slot-scope="scope">
						<span>{{ scope.row.months }}个月</span>
					</template>
					</el-table-column>
					<el-table-column
					prop="price"
					label="价格">
					</el-table-column>
				</el-table>
					<el-alert class="alert"
						title="支付描述"
						:type="alertType"
						:closable="false"
						:description="payDescription">
					</el-alert>
					<el-button v-if="payBtnShow" class="primary pay_btn" @click="renewPay">确认支付</el-button>
				</div>
				<div v-if="!payTableShow" slot="footer" class="dialog-footer">
					<el-button @click="cancel('renewForm', renewDialog = false)">取 消</el-button>
					<el-button class="primary" @click="renewSubmit">提 交</el-button>
				</div>
			</el-dialog>
			<!--产品续费弹窗end-->
			
			<!--产品修改密码弹窗start-->
			<el-dialog :before-close="restChangeKeyForm" title="C9产品修改密码" :visible.sync="changeKeyDialog" width="506px" class="changeKeyDialog">
				<el-form :model="changKeyForm" ref="changKeyForm" :rules="changKeyFormRules">
					<el-form-item label="授权码" :label-width="formLabelWidth">
						<el-input v-model="changKeyForm.code" autocomplete="off" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="newPassword" :label-width="formLabelWidth">
						<el-input type="password" v-model="changKeyForm.newPassword" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="rePassword" :label-width="formLabelWidth">
						<el-input type="password" v-model="changKeyForm.rePassword" autocomplete="off"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="cancel('changKeyForm', changeKeyDialog = false)">取 消</el-button>
					<el-button class="primary" @click="changeKeySubmit">保 存</el-button>
				</div>
			</el-dialog>
			<!--产品修改密码弹窗end-->
			
			<!--编辑授权账号信息start-->
			<el-dialog :before-close="restEditCustomerForm" title="编辑授权账号信息" :visible.sync="editCustomerDialog" width="510px" class="editCustomerDialog">
				<el-form :model="editCustomerForm" ref="editCustomerForm" :rules="editCustomerFormRules">
					<el-form-item label="授权客户名称" prop="name" :label-width="formLabelWidth">
						<el-input v-model="editCustomerForm.name" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="客户联系人" prop="contact_name" :label-width="formLabelWidth">
						<el-input v-model="editCustomerForm.contact_name" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="联系人电话" prop="phone" :label-width="formLabelWidth">
						<el-input v-model="editCustomerForm.phone" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="联系人邮箱" prop="email" :label-width="formLabelWidth">
						<el-input v-model="editCustomerForm.email" autocomplete="off"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="cancel('editCustomerForm', editCustomerDialog = false)">取 消</el-button>
					<el-button class="primary" @click="editCustomerSubmit">保 存</el-button>
				</div>
			</el-dialog>
			<!--编辑授权账号信息end-->

			<!--授权证书start-->
			<el-dialog title="授权证书" :visible.sync="certificateDialog" width="510px" class="editCustomerDialog">
				<img :src="certificateUrl" alt="" width="100%">
				<div slot="footer" class="dialog-footer">
					<el-button class="primary" @click="certificateDialog = false">关闭</el-button>
				</div>
			</el-dialog>
			<!--授权证书end-->

		</div>
	</div>
</template>

<script>
	import { isvalidPhone } from '@/assets/js/validate';
	import {verifyCode, getAuthBySearch, getAuthByProduct, addTrail, updateAuth, 
	buyPrice,buy, getCertificateById}  from "@/api/c9auth";
	import { createGetUrlParams }  from "@/utils/url";
	import { authStatus, edition}  from "@/utils/dataDict";
	import { payVerify }  from "@/utils/pay";
	export default {
		data() {
			//手机号验证
			let validPhone = (rule, value, callback) => {
				if(!value) {
					callback(new Error('请输入电话号码'))
				} else if(!isvalidPhone(value)) {
					callback(new Error('请输入正确的11位手机号码'))
				} else {
					callback()
				}
			}
			//两次密码是否相等
			let validatePass2 = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请再次输入密码'));
				} else if(value !== this.changKeyForm.newPassword) {
					callback(new Error('两次输入密码请保持一致!'));
				} else {
					callback();
				}
			};
			return {
				loading:false,
				meEdition:edition[2],
				verifyCodeResult:{//接收效验code是否已存在结果
					success:false,
					loading:false,
					icon:""
				},
				pagination:{
					use: true,
					total:0,
					size:20,
					currentPage:1,
				},
				codeLoading:false, 
				curentId:0,//选中表格行的id
				currentIndex:0,//选中表格行的元素下标
				payTableShow:false,
				payTableData:[],//支付所需价格表
				payData:"",//需要支付的数据
				payBtnShow:false,
				alertType:"success",
				payDescription:"",
				/*筛选条件*/
				searchOption:{
					openingDateStart:'', //选择开通时间-开始
					openingDateEnd:'',//选择开通时间-结束
					expirationDateStart:'',//选择过期时间-开始
					expirationDateEnd:'',//选择过期时间-结束
					customerName:'',//选择授权客户
					code:''//选择授权码
				},

				/*开通时间start*/
				pickerOptions1: {
					shortcuts: [{
						text: '昨天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 1);
							picker.$emit('pick', date);
						}
					}, {
						text: '最近7天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}, {
						text: '最近30天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', date);
						}
					}, {
						text: '最近90天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', date);
						}
					}, {
						text: '最近1年',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
							picker.$emit('pick', date);
						}
					}]
				},
				pickerOptions2: {
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: '昨天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: '一周前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}]
				},
				/*开通时间end*/

				/*过期时间start*/
				pickerOptions3: {
					shortcuts: [{
						text: '昨天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 1);
							picker.$emit('pick', date);
						}
					}, {
						text: '最近7天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}, {
						text: '最近30天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', date);
						}
					}]
				},
				pickerOptions4: {
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: '昨天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: '一周前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}, {
						text: '一周后',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}, {
						text: '30天后',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
							picker.$emit('pick', date);
						}
					}]
				},
				/*过期时间end*/

				/*表格数据start*/
				tableData: [],
				/*表格数据end*/

				formLabelWidth: '110px',
				
				/*产品试用start*/
				triallDialog: false,
				FBITriallDateValue: '',
				triallForm: {
					code: '', //试用产品授权码
					key: '', //试用产品授权密码
					name: '', //试用产品公司名称
					contact_name: '', //试用产品联系人
					user_count:1,
					phone: '', //试用产品联系电话
					email: '', //试用产品联系邮箱
					trail_days:30,
					edition:"21" //21:C9标准版
				},
				triallFormRules:{
					code: [{
						required: true,
						message: '请输入授权码',
						trigger: 'blur'
					},
					{
						pattern: /^[0-9a-zA-Z]{1,}$/,
						message: "只支持输入数字、字母",
						trigger: "blur"
					}],
					user_count:[{ type: 'number', message: '请输入数字'}],
					key: [{
						required: true,
						message: '请输入授权码密码',
						trigger: 'blur'
					},
					{
						pattern: /^[0-9a-zA-Z]{1,}$/,
						message: "只支持输入数字、字母",
						trigger: "blur"
					}],
					name: [{
						required: true,
						message: '请输入公司名称',
						trigger: 'blur'
					}],
					contact_name: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					email: [
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: 'blur'
						}
					]
				},
				triallDate: [{
						value: 7,
						label: '七天'
					}, {
						value: 15,
						label: '十五天'
					}, {
						value: 30,
						label: '一个月'
					}],
				/*产品试用end*/
				
				/*申请购买产品start*/
				buyFirstDialog: false,
				buyFirstForm: {
					code: '', //产品授权码
					key: '', //产品授权密码
					name: '', //授权客户名称
					contact_name: '', //客户联系人
					phone: '', //联系人手机
					email: '', //联系人邮箱
					user_count: 1, //购买用户数,
					months:12,
					product:1,
					edition:"21",
					pay_type:0

				},
				buyFirstFormRules:{
					code: [{
						required: true,
						message: '请输入授权码',
						trigger: 'blur'
					},
					{
						pattern: /^[0-9a-zA-Z]{1,}$/,
						message: "只支持输入数字、字母",
						trigger: "blur"
					}],
					key: [{
						required: true,
						message: '请输入授权码密码',
						trigger: 'blur'
					},
					{
						pattern: /^[0-9a-zA-Z]{1,}$/,
						message: "只支持输入数字、字母",
						trigger: "blur"
					}],
					name: [{
						required: true,
						message: '请输入公司名称',
						trigger: 'blur'
					}],
					contact_name: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					email: [
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: 'blur'
						}
					],
					user_count:[{ type: 'number', message: '请输入数字'}]
				},
				buyDate: [{
						value: 12,
						label: '一年'
					}, {
						value: 24,
						label: '两年'
					},{
						value: 36,
						label: '三年'
					},
					{
						value: 10000,
						label: '买断'
					}],
				/*申请购买产品end*/
				
				/*产品加点start*/
				addPointDialog: false,
				addC9DateValue: '',
				addPointForm: {
					code: '', //产品授权码
					key: '', //产品授权密码
					name: '', //授权客户名称
					old_user_count:'',//已购买用户数
					user_count:1, //新增用户数
					pay_type:0
				},
				addPointFormRules:{
					user_count: [
						{required: true, message: '请输入新增用户数', trigger: 'blur'},
						{ type: 'number', message: '请输入数字'}
					],
				},
				/*产品加点end*/
				
				/*产品续费start*/
				renewDialog: false,
				renewForm: {
					code: '', //产品授权码
					name: '', //授权客户名称
					old_user_count: '', //已购买用户数
					pay_type:0,
					months:12,

				},
				renewFormRules:{
					months: [
						{required: true, message: '请输入新增用户数', trigger: 'blur'},
						{ type: 'number', message: '请输入数字'}
					],
				},
				/*产品续费end*/
				
				/*产品修改密码start*/
				changeKeyDialog: false,
				changeC9DateValue: '',
				changKeyForm: {
					code: '', //产品授权码
					newPassword: '', //新密码
					rePassword: '', //确认密码
				},
				changKeyFormRules:{
					newPassword: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					},
					{
						pattern: /^[0-9a-zA-Z]{1,}$/,
						message: "只支持输入数字、字母",
						trigger: "blur"
					}],
					rePassword: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					},
					{
						pattern: /^[0-9a-zA-Z]{1,}$/,
						message: "只支持输入数字、字母",
						trigger: "blur"
					}],
				},
				/*产品修改密码end*/
				
				/*编辑授权账号信息start*/
				editCustomerDialog: false,
				editC9DateValue: '',
				editCustomerForm: {
					name: '', //授权客户名称
					contact_name: '', //客户联系人
					phone: '', //联系人手机
					email: '', //联系人邮箱
				},
				editCustomerFormRules:{
					name: [{
						required: true,
						message: '请输入公司名称',
						trigger: 'blur'
					}],
					contact_name: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					phone: [

					],
					email: [
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: 'blur'
						}
					]
				},
				/*编辑授权账号信息end*/
				/*显示授权证书 start*/
				certificateDialog:false,
				certificateUrl:''
				/*显示授权证书 end*/
			};
		},
		mounted(){
			this.getAuthData()
		},
		methods: {
			handleCurrentChange(val){
				this.pagination.currentPage = val
				this.getAuthData()
			},
			handleSizeChange(val){
				if(val <= this.pagination.total){
					this.pagination.size = val
					this.getAuthData()
				}
			},
			resetVerifyCodeResult(){
				this.verifyCodeResult.success = false
				this.verifyCodeResult.loading = false
				this.verifyCodeResult.icon = ""
			},
			verifyCodeOnInput(val){
				if(val){
					this.verifyCodeResult.success = false
					this.verifyCodeResult.loading = true
					this.verifyCodeResult.icon = "el-icon-loading"
					verifyCode({code:val, product:2}).then(() =>{
						this.verifyCodeResult.success = true
						this.verifyCodeResult.loading = false
						this.verifyCodeResult.icon = "el-icon-success"
					}).catch(()=>{
						this.verifyCodeResult.icon = "el-icon-error"
						this.verifyCodeResult.success = false
						this.verifyCodeResult.loading = false
					})
				}else{
					this.verifyCodeResult.icon = ""
					this.verifyCodeResult.success = false
					this.verifyCodeResult.loading = false
				}
			},
			search(){
				this.restPage(true);
				let params = {
					date_start:this.searchOption.openingDateStart,
					date_stop:this.searchOption.openingDateEnd,
					expire_start:this.searchOption.expirationDateStart,
					expire_stop:this.searchOption.expirationDateEnd,
					name:this.searchOption.customerName,
					code:this.searchOption.code
				}
				let result = createGetUrlParams(params)
        console.log(result);
				if (result.success) {
					this.loading = true
					getAuthBySearch(result.data).then(response=>{
						this.tableData = response.results
						this.pagination.total = response.count
						this.loading = false
					}).catch(()=>{
						this.loading = false
					})
					
				}
			},
			restPage(isUsePagination){
				this.pagination.use = isUsePagination
				this.pagination.currentPage = 1
				this.pagination.size = 20
			},
			restSearch(){
				for (const key in this.searchOption) {
					if (this.searchOption.hasOwnProperty(key)) {
						this.searchOption[key] = ''
					}
				}
				this.restPage(true)
				this.getAuthData()	
			},
			getAuthData(){
				this.loading = true
				let params = {
					p:this.pagination.currentPage,
					count:this.pagination.size
				}
				let result = createGetUrlParams(params)
				if (result.success) {
					getAuthBySearch(result.data).then(response=>{
					this.loading = false
						this.pagination.total = response.count | 0
						this.tableData = response.results;
            console.log(this.tableData,'this.tableData');
					}).catch(()=>{
						this.loading = false
					})
					
				}
			},
			getAuthStatus(index){
				return authStatus[index]
			},
			triallDialogOpen(){
				this.resetVerifyCodeResult()
				this.triallForm.trail_days = 30
				this.triallDialog = true
			},
			triallFormSubmit(){//申请试用
				this.$refs.triallForm.validate(valid => {
					if (valid) {
						this.loading = true
						this.triallForm.product = 1 //C9
						addTrail(this.triallForm).then(() =>{
							this.loading = false
							this.$message({
								type: 'success',
								message: '申请试用成功'
							});
							this.getAuthData()
							this.triallDialog = false
						}).catch(()=>{
							this.loading = false
						})
					} else {
						return false
					}
				})
			},
			restTriallForm(done){
				if(this.$refs.triallForm)this.$refs.triallForm.resetFields()
				done()	
			},
			addPointOpen(index, row){ //加点
				this.payTableShow = false
				this.curentId = row.id
				this.addPointForm.code = row.code
				this.addPointForm.key = row.key
				this.addPointForm.name = row.name
				this.addPointForm.old_user_count = row.user_count
				this.addPointDialog = true
			},
			addPointSubmit(){
				this.$refs.addPointForm.validate(valid => {
					if (valid) {
						this.loading = true
						let data = {
							user_count: this.addPointForm.user_count,
							pay_type: this.addPointForm.pay_type
						}
						addUserPrice(this.curentId, data).then(response =>{ //获取此次充值的价格
							response.code = this.addPointForm.code
							this.payTableData[0] = response
							this.payTableShow = true
							
							this.$store.dispatch('user/userinfo') //获取账户余额
							.then(() => {
								this.loading = false
								let finance = {
									special:this.$store.getters.userInfo.finance.c9_point,
									universal:this.$store.getters.userInfo.finance.point
								}
								let parms = {
									price: response.price,
									payType: this.addPointForm.pay_type
								}
								let result = payVerify(parms, finance) //检测余额是否足够
								this.payDescription = result.msg
								this.payBtnShow = result.success

								if(result.success){//余额充足
									this.payData = data
									this.alertType= "success"
								}else{//余额不足
									this.alertType= "error"
								}
							})
							.catch(() => {
								this.loading = false
							})
						}).catch(()=>{
							this.loading = false
						})
					} else {
						return false
					}
				})
			},
			addPointPay(){
				this.loading = true
				addUser(this.curentId, this.payData).then(response =>{
					this.loading = false
					this.$message({
						type: 'success',
						message: '支付成功'
					});
					this.getAuthData()
					this.addPointDialog = false
				}).catch(()=>{
					this.loading = false
				})
			},
			restAddPointForm(done){//重置修改密码表单
				if(this.$refs.addPointForm)this.$refs.addPointForm.resetFields()
				done()
			},
			renewOpen(index, row){//续费
				this.payTableShow = false
				this.curentId = row.id
				this.renewForm.code = row.code
				this.renewForm.name = row.name
				this.renewForm.old_user_count = row.user_count
				this.renewDialog = true
			},
			renewSubmit(){
				this.$refs.renewForm.validate(valid => {
					if (valid) {
						this.loading = true
						let data = {
							months: this.renewForm.months,
							pay_type: this.renewForm.pay_type
						}
						addMonthPrice(this.curentId, data).then(response =>{
							response.code = this.renewForm.code
							this.payTableData[0] = response
							this.payTableShow = true

							this.$store.dispatch('user/userinfo') //获取账户余额
							.then(() => {
								let finance = {
									special:this.$store.getters.userInfo.finance.c9_point,
									universal:this.$store.getters.userInfo.finance.point
								}
								let parms = {
									price: response.price,
									payType: this.renewForm.pay_type
								}
								let result = payVerify(parms, finance) //检测余额是否足够
								this.payDescription = result.msg
								this.payBtnShow = result.success

								if(result.success){//余额充足
									this.payData = data
									this.alertType= "success"
								}else{//余额不足
									this.alertType= "error"
								}
								this.loading = false
							}).catch(()=>{
								this.loading = false
							})
						}).catch(()=>{
							this.loading = false
						})
					} else {
						return false
					}
				})
			},
			renewPay(){
				this.loading = true
				addMonth(this.curentId, this.payData).then(response =>{
					this.loading = false
					this.$message({
						type: 'success',
						message: '支付成功'
					});
					this.getAuthData()
					this.renewDialog = false
				}).catch(()=>{
					this.loading = false
				})

			},
			restRenewForm(done){
				if(this.$refs.renewForm)this.$refs.renewForm.resetFields()
				done()
			},
			changeKeyOpen(index, row){//修改密码
				this.curentId = row.id
				this.currentIndex = index
				this.changKeyForm.code = row.code
				this.changeKeyDialog = true
			},
			changeKeySubmit(){
				this.$refs.changKeyForm.validate(valid => {
					if (valid) {
						this.loading = true
						let data = {
							key: this.changKeyForm.newPassword
						}
						updateAuth(this.curentId, data).then(response =>{
							this.loading = false
							this.$message({
								type: 'success',
								message: '修改密码成功'
							});
							this.getAuthData()
							this.changeKeyDialog = false
						}).catch(()=>{
							this.loading = false
						})
					} else {
						return false
					}
				})
			},
			restChangeKeyForm(done){//重置修改密码表单
				if(this.$refs.changKeyForm)this.$refs.changKeyForm.resetFields()
				done()
			},
			editCustomerOpen(index, row){//编辑信息
				this.curentId = row.id
				this.currentIndex = index
				this.editCustomerForm.name = row.name
				this.editCustomerForm.contact_name = row.contact_name
				this.editCustomerForm.phone = row.phone
				this.editCustomerForm.email = row.email
				this.editCustomerDialog = true
			},
			editCustomerSubmit(){
				this.$refs.editCustomerForm.validate(valid => {
					if (valid) {
						this.loading = true
						updateAuth(this.curentId, this.editCustomerForm).then(response =>{
							this.loading = false
							this.$message({
								type: 'success',
								message: '更新客户信息成功'
							});
							this.tableData[this.currentIndex].name = response.name
							this.tableData[this.currentIndex].contact_name = response.contact_name
							this.tableData[this.currentIndex].phone = response.phone
							this.tableData[this.currentIndex].email = response.email
							//this.tableData[this.currentIndex] = response
							this.editCustomerDialog = false
						}).catch(()=>{
							this.loading = false
						})
					} else {
						return false
					}
				})
			},
			restEditCustomerForm(done){
				if(this.$refs.editCustomerForm)this.$refs.editCustomerForm.resetFields()
				done()
			},
			certificateOpen(index, row){ //显示授权证书
				this.certificateUrl = ''
				this.loading = true
				getCertificateById(row.id).then(response =>{
					this.certificateUrl = response.url
					this.loading = false
					this.certificateDialog = true
				}).catch(()=>{
					this.loading = false
				})
				
			},
			buyFirstDialogOpen(){//申请购买
				this.payTableShow = false
				this.resetVerifyCodeResult()
				this.buyFirstForm.months = 12
				this.buyFirstDialog = true
			},
			buyFirstSubmit(){
				this.$refs.buyFirstForm.validate(valid => {
					if (valid) {
						this.loading = true
						this.buyFirstForm.product = 1 //C9
						let data = {
							user_count: this.buyFirstForm.user_count,
							months: this.buyFirstForm.months,
							pay_type: this.buyFirstForm.pay_type,
							product:1,
							edition:this.buyFirstForm.edition
						}
						buyPrice(data).then(response =>{ //获取此次充值的价格
							response.code = this.buyFirstForm.code
							this.payTableData[0] = response
							this.payTableShow = true
							
							this.$store.dispatch('user/userinfo') //获取账户余额
							.then(() => {
								this.loading = false
								let finance = {
									special:this.$store.getters.userInfo.finance.c9_point,
									universal:this.$store.getters.userInfo.finance.point
								}
								let parms = {
									price: response.price,
									payType: this.buyFirstForm.pay_type
								}
								let result = payVerify(parms, finance) //检测余额是否足够
								this.payDescription = result.msg
								this.payBtnShow = result.success

								if(result.success){//余额充足
									this.payData = data
									this.alertType= "success"
								}else{//余额不足
									this.alertType= "error"
								}
							})
							.catch(() => {
								this.loading = false
							})
						}).catch(()=>{
							this.loading = false
						})
					} else {
						return false
					}
				})
			},
			firstBuySure(){
				this.loading = true
				buy(this.buyFirstForm).then(response =>{
					this.loading = false
					this.$message({
						type: 'success',
						message: '支付成功'
					});
					this.getAuthData()
					this.buyFirstDialog = false
				}).catch(()=>{
					this.loading = false
				})
			},
			restbuyFirstForm(done){
				if(this.$refs.buyFirstForm)this.$refs.buyFirstForm.resetFields()
				done()
			},
			cancel(formName, close){
				this.$refs[formName].resetFields()
			}
		}
	};
</script>

<style lang="scss">
	@import url("../../assets/css/product.css");
	.C9_products{
		.main{
			display: flex;
			flex-direction:column;
			margin: 0px 14px;
			height: 100%;
			//background-color: #FFFFFF;
			position: absolute;
			top: 0px;
			bottom: 0px;
			left: 0px;
			right: 0px;
			.main_title{
				margin:15px 0;
			}
			.product-selector{
				background: #fff;
			}
			.product-main-list{
				flex-grow:1;
				height: 50%;
			}
		}
		.alert{
			margin-bottom: 10px;
		}
		.pay_btn{
			float: right;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/product/C9_products.vue